import React, { useEffect } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import SendIcon from '@mui/icons-material/Send';
import ContactForm, { ContactFormId } from './ContactForm'

function RequestService(props:{ service:string }) {
  const {service} = {... props}
  const [open, setOpen] = React.useState(false);
  const [sended, setSended] = React.useState(false);
  const [confirmed, setConfirmed] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false)
    setSended(false)
  };
  const handleSend = () => {
    setSended(true);
  };
  useEffect(()=>{
    if(open && confirmed ){
      handleClose()
      setConfirmed(false)
    }
  }, [confirmed])


  return (
    <>
    <Button variant='contained' onClick={handleClickOpen}>
      Solicitar
    </Button>
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle textAlign="center">Solicitar servicio</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Por favor, describa el requerimiento a detalle.
        </DialogContentText>
        
        <ContactForm
          flat onDialog
          serviceSelected={service}
          sended={sended}
          setConfirmed={setConfirmed}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button
          variant="contained"
          type="submit"
          onClick={handleSend}
          endIcon={<SendIcon/>}
          form={ContactFormId}
        >
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
    </>
  )
}

export default RequestService